import axios from "axios";
import qs from "qs";
import Config from "@/config";
import router from "@/router";
// import { Message } from 'element-ui'
import LStore from "store";
import store from "@/store";

const fetch = axios.create({
  // baseURL: Config.url,
  timeout: 100000,
  crossDomain: true,
  withCredentials: true,
  headers: {
    // 'lang': 'zh',
    // 'os': 1,
    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
  }
});

fetch.interceptors.request.use(
  config => {
    config.params = {
      ...config.params,
      lang: store.state.language
    };
    // console.log('interceptors request', config)
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

fetch.interceptors.response.use(
  config => {
    // console.log('interceptors response', config)
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

fetch.http = params => {
  return Promise.resolve(
    fetch({
      baseURL: params.isContract ? Config.contractUrl : Config.url,
      headers: params.headers,
      url: params.url,
      method: params.method || "POST",
      params: params.params,
      data:
        params.data instanceof FormData
          ? params.data
          : qs.stringify(params.data)
    })
  );
};

export function $http(params) {
  return new Promise(resolve => {
    fetch.http(params).then(res => {
      if (/^(-3)$/.test(res.data.code)) {
        store.commit("USER_INFO", null);
        store.commit("IS_LOGIN", false);
        LStore.remove("anselmUserInfo");

        router.push({
          path: "login"
        });
      } else {
        resolve(res.data);
      }
    });
  });
}
